import React from 'react'

const Top10 = () => {
  return (
    <div>Top10</div>
  )
}

export default Top10